import { ChangeEvent } from 'react'
import classNames from 'classnames'

type TProps = {
  onChange: (val: ChangeEvent<HTMLInputElement>) => void
  name?: string
  checked?: boolean
  id?: string
  label?: string
  subtext?: string
  defaultChecked?: boolean
  className?: string
  disabled?: boolean
}

const Checkbox = ({
  id,
  label,
  subtext,
  defaultChecked,
  checked,
  className,
  onChange,
  disabled,
  name,
}: TProps) => {
  return (
    <label className={classNames('checkbox-with-label', '-checkbox', className)}>
      <input
        className={'checkbox-with-label__input'}
        id={id}
        defaultChecked={defaultChecked}
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        type="checkbox"
        name={name}
      />
      <div
        className={classNames('checkbox-with-label__checkbox', { '-disabled': disabled })}
        aria-label={name}
      />
      {subtext ? (
        <div>
          <div className="top-label">{label}</div>
          <div className="bottom-label">{subtext}</div>
        </div>
      ) : (
        <div>
          <div className="top-label">{label}</div>
        </div>
      )}
    </label>
  )
}

export default Checkbox
